import { render, staticRenderFns } from "./CartOverview.vue?vue&type=template&id=51404d9b"
import script from "./CartOverview.vue?vue&type=script&lang=js"
export * from "./CartOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports